module.exports = __webpack_public_path__ + "static/media/6.0b8e9c8f.jpg";